import Icon from "~/components/ui/Icon"
import { useUser } from "~/hooks/useUser"
import SendCustomEventOnView from "~/components/analytics/SendCustomEventOnView"
import { useHydrated } from "@tanstack/react-router"

export default function DesktopAccount() {
    const { user } = useUser()
    const hydrated = useHydrated()
    const returnUrl = hydrated ? globalThis.location?.href : undefined
    const loginHref = returnUrl ? `/login?returnUrl=${encodeURIComponent(returnUrl)}` : '/login'
    const logoutHref = returnUrl
        ? `/api/vtexid/pub/logout?scope=miess&returnUrl=${encodeURIComponent(returnUrl)}`
        : '/api/vtexid/pub/logout?scope=miess'

    return (
        <div className='group relative flex flex-col items-center justify-center gap-1 cursor-pointer'>
            <a
                href={user?.value?.email ? '/account' : loginHref}
                className='flex flex-col gap-1 items-center'
            >
                <Icon id='Login' size={36} className='text-orange' />
                <span className='font-bold text-xs'>Minha Conta</span>
            </a>

            {/* Hover Menu */}
            <div className='hidden group-hover:block left-1/2 -translate-x-1/2 rotate-45 top-[calc(100%-10px)] w-5 h-5 bg-black absolute' />

            <div className='hidden group-hover:block text-center bg-white text-black w-[240px] absolute top-full right-0 z-[2] shadow-xl'>
                <div className='p-3 w-full bg-black text-white font-bold'>
                    <p className='text-base'>Bem-vindo(a)!</p>
                </div>

                {user?.value?.email
                    ? (
                        <>
                            <SendCustomEventOnView
                                event={[
                                    {
                                        label: 'visitorContactInfo',
                                        value: `${user?.value?.email}, ${user?.value?.givenName}`,
                                    },
                                ]}
                            />
                            <div className='text-center p-3 space-y-3 text-base'>
                                <p className='overflow-hidden text-ellipsis'>
                                    Olá! {user?.value?.givenName ?? user?.value?.email}
                                </p>

                                <div className='font-bold flex flex-col'>
                                    <a href='/account#/orders'>Meus Pedidos</a>
                                    <a href='/account'>Meu Cadastro</a>
                                </div>

                                <a
                                    href={logoutHref}
                                    className='underline text-sm'
                                >
                                    Sair
                                </a>
                            </div>
                        </>
                    )
                    : (
                        <a
                            href={loginHref}
                            className='block text-sm p-3 w-full'
                        >
                            Cadastre-se ou faça seu login
                        </a>
                    )}
            </div>
        </div>
    )
}
